import {
  FloorPrice,
  ProductPrice,
  ProjectPrice,
  RoomPrice
} from "shared/types/__generated__/graphql"

export const PriceAPIType = "price_information" as const
export const PricesAPIType = "prices" as const
export const PriceListsAPIType = "price_lists" as const
export const PriceListTypename = "PriceList" as const
export const PriceGroupTypename = "PriceGroup" as const
export const PriceGroupsAPIType = "price_groups" as const
export const PriceComponentsAPIType = "price_components" as const
export const ProjectPriceTypename = "ProjectPrice" as const
export const RoomPriceTypeName = "RoomPrice" as const
export const FloorPriceTypeName = "FloorPrice" as const
export const ProductPositionPriceTypeName = "ProductPrice" as const

export type Price = ProjectPrice | RoomPrice | FloorPrice | ProductPrice

export enum PriceGroupType {
  ORIGINAL = "original",
  SPECIAL = "special"
}
